//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    active: {
      type: Number,
      required: true,
    },
  },
  methods: {
    toggleTab(index) {
      this.$emit("update:active", index);
    },
  },
};
